import http from '@/services'

export class AuthService {
  constructor(userType) {
    this._baseURL =
      userType === 'common'
        ? (localStorage.getItem('API_URL') ||
            process.env.VUE_APP_BASEURL ||
            'http://localhost:8000/api/') + 'auth/'
        : (localStorage.getItem('API_URL') ||
            process.env.VUE_APP_BASEURL ||
            'http://localhost:8000/api/') + 'auth-guests/'

    this._loginURL = this._baseURL + 'login'
    this._authUserURL = this._baseURL + 'me'
    this._logoutUrl = this._baseURL + 'logout'
    if (userType === 'guest')
      this._guestAuthorization = this._baseURL + 'authorization'

    this._lastUserFilial = localStorage.getItem('LAST_USER_FILIAL')
      ? JSON.parse(localStorage.getItem('LAST_USER_FILIAL'))
      : []
  }

  getLastUserFilial(username) {
    if (this._lastUserFilial.length > 0) {
      const user = this._lastUserFilial.filter(
        (element) => element.user == username
      )

      return user[0] ? user[0].filial : undefined
    } else undefined
  }

  async loginUser(userData) {
    let filial = this.getLastUserFilial(userData.NOME)
    if (filial) userData.filial = filial

    const userData64 = {
      NOME: btoa(btoa(userData.NOME) + 'gw'),
      password: btoa(btoa(userData.password) + 'gw'),
    }
    
    const response = await http.post(this._loginURL, userData64)
    return response
  }

  async getAuthUser(token) {
    return await http.post(this._authUserURL, { token: token })
  }

  async getGuestAuthentication(payload) {
    let requestUrl = this._guestAuthorization
    return await http.post(requestUrl, { ...payload })
  }

  async logoutUser() {
    return await http.post(this._logoutUrl)
  }
}

export default AuthService
